"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStatePlacement = useStatePlacement;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _constants = require("../../form/constants");

function useStatePlacement(isOpen) {
  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isBottomPlacement = _useState2[0],
      setIsBottomPlacement = _useState2[1];

  var inputProps = {
    borderRadius: _constants.INPUT_BORDER_RADIUS
  };
  var listProps = {
    borderRadius: 0
  };

  if (isOpen) {
    if (isBottomPlacement) {
      inputProps.borderRadius = _constants.BOTTOM_PLACEMENT_BORDER_RADIUS;
      listProps.borderRadius = _constants.LIST_BORDER_RADIUS;
    } else {
      inputProps.borderRadius = _constants.TOP_PLACEMENT_BORDER_RADIUS;
      listProps.borderRadius = _constants.LIST_BORDER_RADIUS;
    }
  }

  var onPlacementChange = function onPlacementChange(placement) {
    return setIsBottomPlacement(placement.includes('bottom'));
  };

  return {
    onPlacementChange: onPlacementChange,
    inputProps: inputProps,
    listProps: listProps
  };
}